<div class="loader-container">
  <div class="loader-icon"></div>
</div>
